import { BROADCAST_SET_SCENES_WITH_SOURCE } from 'actions/Types';
import { deleteSource } from 'actions/Broadcast';
import {
  showModal,
  deleteBackground,
  deleteOverlay,
  deleteBanner
} from '@shoflo/studio-redux/actions';
import { DELETE_SOURCE_FORM } from 'constants/ModalTypes';
import { setProgram } from 'actions/Broadcast';

/**
 * check source is in scenes
 *
 * @param {string} sourceId - the id of the source to delete
 * @param {Object} deleteParams - extra parameters
 */
export default (sourceId, deleteParams = {}) => {
  return (dispatch, getState) => {
    const {
      broadcastScenes: { scenes }
    } = getState();

    const scenesWithSource = [];

    scenes.forEach((scene, index) => {
      if (!deleteParams.isBackgroundSource) {
        scene.layers.forEach(layer => {
          // layer._id within the condition handles the case where source is an overlay,
          // then the layer._id is the id of the overlay
          if (layer.source._id === sourceId || layer._id === sourceId) {
            scenesWithSource.push({ ...scene, position: index + 1 });
          }
        });
      } else {
        if (scene.style && scene.style.backgroundId === sourceId) {
          scenesWithSource.push({ ...scene, position: index + 1 });
        }
      }
    });

    const action = {
      type: BROADCAST_SET_SCENES_WITH_SOURCE,
      payload: scenesWithSource
    };

    if (scenesWithSource.length) {
      dispatch(action);
      dispatch(showModal(DELETE_SOURCE_FORM, { sourceId, deleteParams }));
    } else {
      if (deleteParams.isBackgroundSource) {
        dispatch(deleteBackground(sourceId));
      } else if (deleteParams.isOverlaySource) {
        dispatch(deleteOverlay(sourceId));
      } else if (deleteParams.isBannerSource) {
        dispatch(deleteBanner(sourceId, {}, setProgram));
      } else {
        dispatch(deleteSource(sourceId, deleteParams));
      }
    }
  };
};
